// Create a debounce wrapper function, returns a promise that reduxForm can handle
export const debounceAsyncValidate = (fn, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    return new Promise((resolve, reject) => {
      timer = setTimeout(() => {
        fn(...args)
          .then(resolve)
          .catch(reject);
      }, delay);
    });
  };
};
